import React from 'react';
import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';
import css from '~/components/TeamStatsGetTheApp/TeamStatsGetTheApp.scss';
import GetTheAppLinks from '~/constants/GetTheAppLinks';
import logEvent from '~/util/analytics';
import { FormattedMessage } from 'react-intl';

const handleClick = leagueSlug => {
  logEvent('conversion', {
    type: `${leagueSlug}_team_stats_get_the_app`,
    campaign: 'thescoreapp',
  });
};

// eslint-disable-next-line react/prefer-stateless-function
class TeamStatsGetTheApp extends React.Component {
  render() {
    const link = GetTheAppLinks[`${this.props.leagueSlug.toLowerCase()}_team_stats_get_the_app`];
    return (
      <div>
        <div className={css.content}>
          <div className={css.caption}>Get deeper into the game</div>
          <div className={css.getTheAppButton}>
            <div className={css.buttonBackground} />
            <a href={link} onClick={() => handleClick(this.props.leagueSlug)}>
              <div className={css.getTheAppText}>
                <FormattedMessage id="teamstats.get_the_app" defaultMessage="Get the app" />
              </div>
            </a>
          </div>
        </div>
        <div className={css.coverGradient} />
      </div>
    );
  }
}

TeamStatsGetTheApp.propTypes = {
  leagueSlug: PropTypes.string.isRequired,
};

TeamStatsGetTheApp.displayName = 'TeamStatsGetTheApp';

export default StyledComponent(TeamStatsGetTheApp, [css]);
